import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SpxNgSeepexIconsService } from './icons.service';

@NgModule({
  declarations: [],
  imports: [MatIconModule, CommonModule],
  exports: [],
  providers: [SpxNgSeepexIconsService],
})
export class SeepexIconsModule {}
